import React, { useState, useEffect } from 'react'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Form, Input, Select, TreeSelect, message, Slider, Typography, InputNumber } from 'antd'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import bxlutils from 'bxl-utils'
import BrandSelect from '@components/BrandSelect'
import { SORT_TYPE } from '@lib/constant'
import legoService from '@services/lego'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import utils from '@utils/utils'
import { useSelector } from 'react-redux'
const { TreeNode } = TreeSelect
const FormItem = Form.Item
const Option = Select.Option
const treeSelect = (children: any, parentName?: string) => {
  return children && children.length > 0 ? (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    children.map((item: any, index: number) => {
      return (
        <TreeNode
          value={item.category.id}
          title={`${item.category.id}-${parentName ? parentName + '-' : ''}${
            item.category.displayTerm
          }(${item.category.term})`}
          key={item.category.id}
        >
          {item.children &&
            item.children.length > 0 &&
            treeSelect(
              item.children,
              `${parentName ? parentName + '-' : ''}${item.category.displayTerm}`
            )}
        </TreeNode>
      )
    })
  ) : (
    <div></div>
  )
}
const formItemLayout = {
  labelCol: {
    xs: {
      span: 4,
    },
    sm: {
      span: 4,
    },
  },
  wrapperCol: {
    xs: {
      span: 16,
    },
    sm: {
      span: 16,
    },
  },
}
interface IParams {
  tg?: string[]
  ntg?: string[]
  s?: string
  l2?: string[]
  cids?: string[]
  ncids?: string[]
  nb?: string[]
  b?: string[]
  m?: string[]
  promoId?: string[]
  prs?: string
}
const renderSelect = (
  mode: 'multiple' | 'tags',
  values: Array<string> | undefined,
  label: string,
  placeholder: string,
  options: Array<any>,
  errorInput: any,
  onChange: any
) => {
  return (
    <Form.Item {...formItemLayout} label={label}>
      <Select
        mode={mode}
        placeholder={placeholder}
        style={errorInput ? { borderColor: 'red' } : {}}
        value={values || []}
        onChange={onChange}
      >
        {options.map((item: any) => {
          // eslint-disable-next-line react/jsx-key
          return <Option value={item.id}>{item.id}</Option>
        })}
      </Select>
    </Form.Item>
  )
}
const ProductSearch = props => {
  const { setParams } = props
  const [normalLink, setNormalLink] = useState('')
  const [params, setparams] = useState<IParams>({})
  const merchants = useSelector<any>(store => store.baseData.merchants) as any
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errorInput, seterrorInput] = useState(false)
  const [categoryTree, setcategoryTree] = useState([])
  const [promoCodesList, setpromoCodesList] = useState([])
  const { tg, ntg, s, promoId, cids, l2, m, b, nb, ncids, prs } = params
  const [fromPrice, setfromPrice] = useState(0)
  const [toPrice, settoPrice] = useState(0)
  const options: Array<any> = []
  useEffect(() => {
    getCategories()
  }, [])
  const getCategories = () => {
    legoService
      .getCategories()
      .then(res => {
        setcategoryTree(res.data.children)
      })
      .catch(err => {
        console.log(err)
      })
  }
  const getPromocodeList = merchantId => {
    legoService
      .getMerchantPromocode(merchantId)
      .then(res => {
        if (res.data) {
          setpromoCodesList(res.data)
        } else {
          message.error(res.response.data)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
  const changeParams = (key, value) => {
    setparams(Object.assign(params, { [key]: value }))
    setParams(Object.assign(params, { [key]: value }))
    setNormalLink(
      `https://baleen-cdn-g.bybieyang.com/lego/search/index.html?${bxlutils.uri.stringify(params)}`
    )
  }
  const setPriceRange = (key, value) => {
    let lowPrice = fromPrice ? fromPrice : 0
    let highPrice = toPrice ? toPrice : 0
    if (key === 'fromPrice') {
      lowPrice = value
      setfromPrice(value)
    }
    if (key === 'toPrice') {
      highPrice = value
      settoPrice(value)
    }
    if (highPrice > lowPrice) {
      changeParams('prs', `c${lowPrice}-${highPrice}`)
    } else {
      changeParams('prs', `c${lowPrice}`)
    }
  }
  return (
    <>
      <FormItem label="关键词">
        <Input onChange={e => changeParams('q', e.target.value.trim())}></Input>
      </FormItem>
      <Form.Item {...formItemLayout} label="选择Tags">
        <Select
          mode="tags"
          placeholder="请选择Tags"
          value={tg || []}
          onChange={val =>
            changeParams(
              'tg',
              val?.map(item => item?.trim())
            )
          }
        >
          {options.map(item => {
            // eslint-disable-next-line react/jsx-key
            return <Option value={item.id}>{item.id}</Option>
          })}
        </Select>
      </Form.Item>
      {renderSelect('tags', ntg, '请选择排除Tags', '排除Tags', [], errorInput, (val: any) =>
        changeParams(
          'ntg',
          val?.map(item => item?.trim())
        )
      )}
      <Form.Item {...formItemLayout} label="排序">
        <Select style={{ width: 200 }} value={s || ''} onChange={e => changeParams('s', e)}>
          {SORT_TYPE.map(item => {
            return (
              <Option value={item.value} key={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="折扣码">
        <Select
          showSearch
          optionFilterProp="children"
          placeholder="请选择商家"
          filterOption={(input, option) =>
            option && option.props && option.props.children
              ? option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              : false
          }
          onChange={getPromocodeList}
        >
          {merchants.map(item => {
            return (
              <Option value={item['id']} key={item['id']}>
                {item['label']}
              </Option>
            )
          })}
        </Select>
        <Select
          showSearch
          mode="tags"
          optionFilterProp="children"
          placeholder="请选择折扣码"
          value={promoId || []}
          filterOption={(input, option) =>
            option && option.props && option.props.children
              ? option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              : false
          }
          onChange={e =>
            changeParams(
              'promoId',
              e?.map(item => item?.trim())
            )
          }
        >
          {promoCodesList &&
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            promoCodesList.map((item, index) => {
              // eslint-disable-next-line react/jsx-key
              return <Option value={item['spec']['id']}>{item['spec']['name']}</Option>
            })}
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="选择商家">
        <Select
          showSearch
          optionFilterProp="children"
          mode="tags"
          placeholder="请选择商家"
          style={errorInput ? { borderColor: 'red' } : {}}
          value={m || []}
          filterOption={(input, option) =>
            option && option.props && option.props.children
              ? option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              : false
          }
          onChange={e =>
            changeParams(
              'm',
              e?.map(item => item?.trim())
            )
          }
        >
          {merchants.map(item => {
            return (
              <Option value={item['id']} key={item['id']}>
                {item['label']}
              </Option>
            )
          })}
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="选择品牌">
        <BrandSelect
          brandList={b}
          mode={'tags'}
          placeholder={'请选择品牌'}
          handleChange={val =>
            changeParams(
              'b',
              val?.map(item => item?.trim())
            )
          }
        ></BrandSelect>
      </Form.Item>
      <Form.Item {...formItemLayout} label="排除品牌">
        <BrandSelect
          brandList={nb}
          mode={'tags'}
          placeholder={'请选择排除品牌'}
          handleChange={val =>
            changeParams(
              'nb',
              val?.map(item => item?.trim())
            )
          }
        ></BrandSelect>
      </Form.Item>
      <Form.Item {...formItemLayout} label="商品价格($)">
        <InputNumber
          min={0}
          value={fromPrice / 100 || 0}
          formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          // parser={value => (value ? value.replace(/\$\s?|(,*)/g, '') : '')}
          onChange={val => setPriceRange('fromPrice', val * 100)}
        />
        -
        <InputNumber
          value={toPrice / 100 || 0}
          formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          // parser={value => (value ? value.replace(/\$\s?|(,*)/g, '') : '')}
          onChange={val => setPriceRange('toPrice', val * 100)}
        />
      </Form.Item>
      <Form.Item {...formItemLayout} label="labels">
        <Input
          value={l2}
          placeholder="请填写labels"
          onChange={val => changeParams('l2', val.target.value.trim())}
        ></Input>
      </Form.Item>
      <Form.Item {...formItemLayout} label="categorys">
        <TreeSelect
          showSearch
          style={{ width: 300 }}
          value={cids || []}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          placeholder="Please select"
          allowClear
          multiple
          // treeDefaultExpandAll
          onChange={val => changeParams('cids', val)}
        >
          {treeSelect(categoryTree)}
        </TreeSelect>
      </Form.Item>
      <Form.Item {...formItemLayout} label="排除categorys">
        <TreeSelect
          showSearch
          style={{ width: 300 }}
          value={ncids || []}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          placeholder="填写排除categorys"
          allowClear
          multiple
          // treeDefaultExpandAll
          onChange={val => changeParams('ncids', val)}
        >
          {treeSelect(categoryTree)}
        </TreeSelect>
      </Form.Item>

      {/* <Form.Item {...formItemLayout} label="折扣范围">
        <Slider
          style={{ width: 300 }}
          range
          min={0}
          max={10}
          tooltipVisible
          marks={marks}
          defaultValue={[0, 10]}
          onChange={value => changeParams('discountRange', value)}
          value={discountRange || [0, 10]}
          step={0.1}
        />
      </Form.Item>
       */}
      <Form.Item label="Normal link">
        <Typography.Paragraph style={{ marginBottom: 0 }} copyable>
          {normalLink}
        </Typography.Paragraph>
      </Form.Item>
    </>
  )
}

export default ProductSearch
